module.exports = __webpack_public_path__ + "static/media/simpsons_mob.411f4ee8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/simpsons_mob.gif
// module id = 199
// module chunks = 0